import React from 'react'

import type { TeamMemberItem } from '../../Team.types'
import { TeamMember } from '../TeamMember/TeamMember'
import type { TeamMemberDropdownProps } from '../TeamMemberDropdown/TeamMemberDropdown'
import { TeamMemberDropdown } from '../TeamMemberDropdown/TeamMemberDropdown'
import * as S from './TeamMemberListItem.styled'

type TeamMemberListItemProps = {
  teamMember: TeamMemberItem
  dropdownProps: Omit<TeamMemberDropdownProps, 'teamMember'>
}

export const TeamMemberListItem = ({ teamMember, dropdownProps }: TeamMemberListItemProps) => {
  return (
    <S.Container>
      <S.TeamMemberWrapper>
        <TeamMember teamMember={teamMember} />
      </S.TeamMemberWrapper>

      <TeamMemberDropdown {...dropdownProps} teamMember={teamMember} />
    </S.Container>
  )
}
